import { http, HttpResponse, delay } from 'msw';

import {
  mockDevicesMetrics,
  mockMacDevice,
  mockMdmDevicesMetrics,
  mockOsEndOfLife,
  mockReportingDevice,
} from '@/mocks/data/deviceData';

export const deviceHandlers = [
  // Specific routes first: `/metrics` and `/mdm-metrics` would otherwise be
  // swallowed by the `:deviceId` routes below.
  http.get('*/v1/organizations/:organizationId/devices/metrics', async () => {
    await delay();
    return HttpResponse.json(mockDevicesMetrics, { status: 200 });
  }),

  http.get(
    '*/v1/organizations/:organizationId/devices/mdm-metrics',
    async () => {
      await delay();
      return HttpResponse.json(mockMdmDevicesMetrics, { status: 200 });
    }
  ),

  http.post('*/v1/organizations/:organizationId/devices', async () => {
    await delay();
    return HttpResponse.json(mockMacDevice, { status: 201 });
  }),

  http.patch(
    '*/v1/organizations/:organizationId/devices/:deviceId',
    async () => {
      await delay();
      return HttpResponse.json(mockMacDevice, { status: 200 });
    }
  ),

  http.delete(
    '*/v1/organizations/:organizationId/devices/:deviceId',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),

  http.delete(
    '*/v1/maintenance/organizations/:organizationId/test-devices/:deviceId',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),

  http.post(
    '*/v1/organizations/:organizationId/devices/:deviceId/lock',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),

  http.post(
    '*/v1/organizations/:organizationId/devices/:deviceId/wipe',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),

  http.post('*/v1/devices/email', async () => {
    await delay();
    return new HttpResponse(null, { status: 204 });
  }),

  // device-reporting service (VITE_DEVICE_BASE_URL, which ends in /v1). Paths omit `/v1` so they also match in Storybook, where `window._env_` is not defined and the base URL is empty.
  http.post(
    '*/organizations/:organizationId/devices/:deviceId/fake-device',
    async () => {
      await delay();
      return HttpResponse.json(mockReportingDevice, { status: 200 });
    }
  ),

  http.get(
    '*/organizations/:organizationId/os/end-of-life',
    async ({ request }) => {
      const product = new URL(request.url).searchParams.get('product');
      const results = product
        ? mockOsEndOfLife.filter(eol => eol.product === product)
        : mockOsEndOfLife;
      await delay();
      return HttpResponse.json(
        { results, total: results.length },
        { status: 200 }
      );
    }
  ),
];
